import { Box, Button, Divider, IconButton, Typography } from "@mui/material";
import moment from "moment";
import pxToRem from "theme/base/pxToRem";
import { useEffect, useMemo, useState } from "react";
import { ReactComponent as IconDownload } from "assets/svg/20-download.svg";
import { ReactComponent as IconArrowHeadDown } from "assets/svg/chevron_down.svg";

import { useDispatch, useSelector } from "react-redux";
import {
  formFilterHrReportSelector,
  listHrReportSelector,
  // listHrReportStatusSelector,
} from "modules/DeclareLeave/redux/selector";
import ViewTable from "modules/DeclareLeave/components/CustomTable";
import EmptyState from "components/common/EmptyState";
import {
  EXPORT_TYPE,
  formFilterHrReportReset,
  formFilterHrReportUpdate,
  resetFilter,
} from "modules/DeclareLeave/redux/formFilterHrReport";
import {
  getHrReportStart,
  resetHrReport,
} from "modules/DeclareLeave/redux/getHrReport";
import {
  resetControlPageFilter,
  setupControlPage,
} from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";
import useColumns from "./useColumns";

import { CustomCalendar } from "./CustomCalendar";
import { exportHrReportStart } from "modules/DeclareLeave/redux/exportHrReport";
import { TableWrapper } from "../styles";

import CustomPopover from "components/common/CustomPopover";
import FilterReport from "./FilterReport";

const listReports = [
  {
    label: "BC chấm công của CBNV",
    value: EXPORT_TYPE.CHECK_IN_OUT,
  },
  {
    label: "BC ngày phép",
    value: EXPORT_TYPE.LEAVE_REPORT,
  },
  {
    label: "BC đi muộn về sớm",
    value: EXPORT_TYPE.LATE_EARLY_REPORT,
  },
  {
    label: "BC nghỉ bù",
    value: EXPORT_TYPE.COMPENSATORY_LEAVE_REPORT,
  },
  {
    label: "BC chi tiết chấm công",
    value: EXPORT_TYPE.TIMEKEEPING_DETAIL,
  },
];

export const ListReport = () => {
  const dispatch = useDispatch();
  const {
    summaryReportCols,
    leaveDaysCols,
    compensatoryLeaveCols,
    lateEarlyCols,
    timekeepingFormCols,
  } = useColumns();
  const { type } = useSelector(formFilterHrReportSelector);
  const { data, totalRecords } = useSelector(listHrReportSelector);
  // const status = useSelector(listHrReportStatusSelector);

  const [fromMonthSelected, setFromMonthSelected] = useState(moment());
  const [toMonthSelected, setToMonthSelected] = useState(moment());

  const handleChangeFromMonth = (newValue) => {
    setFromMonthSelected(newValue);
    const timeSelected = {
      fromMonth: newValue.month() + 1,
      fromYear: newValue.year(),
    };

    dispatch(
      formFilterHrReportUpdate({
        ...timeSelected,
      })
    );

    dispatch(resetControlPageFilter({ id: "hrReport", limit: 100 }));
    dispatch(resetHrReport());
    dispatch(getHrReportStart());
  };

  const handleChangeToMonth = (newValue) => {
    setToMonthSelected(newValue);
    const timeSelected = {
      toMonth: newValue.month() + 1,
      toYear: newValue.year(),
    };

    dispatch(
      formFilterHrReportUpdate({
        ...timeSelected,
      })
    );

    dispatch(resetControlPageFilter({ id: "hrReport", limit: 100 }));
    dispatch(resetHrReport());
    dispatch(getHrReportStart());
  };

  const resetTimeSelected = () => {
    dispatch(resetFilter());
    setFromMonthSelected(moment());
    setToMonthSelected(moment());
    dispatch(
      formFilterHrReportUpdate({
        fromMonth: moment().month() + 1,
        fromYear: moment().subtract(1, "months").year(),
        toMonth: moment().month() + 1,
        toYear: moment().year(),
      })
    );
    dispatch(resetControlPageFilter({ id: "hrReport", limit: 100 }));
    dispatch(resetHrReport());
    dispatch(getHrReportStart());
  };

  const handleExport = () => {
    dispatch(exportHrReportStart());
  };

  const columns = useMemo(() => {
    switch (type) {
      case EXPORT_TYPE.CHECK_IN_OUT:
        return summaryReportCols;
      case EXPORT_TYPE.LEAVE_REPORT:
        return leaveDaysCols;
      case EXPORT_TYPE.COMPENSATORY_LEAVE_REPORT:
        return compensatoryLeaveCols;
      case EXPORT_TYPE.LATE_EARLY_REPORT:
        return lateEarlyCols;
      case EXPORT_TYPE.TIMEKEEPING_DETAIL:
        return timekeepingFormCols;
    }
  }, [type, leaveDaysCols, summaryReportCols]);

  useEffect(() => {
    dispatch(setupControlPage({ id: "hrReport", limit: 100 }));
    dispatch(getHrReportStart());

    return () => {
      dispatch(resetHrReport());
      dispatch(formFilterHrReportReset());
    };
  }, []);

  return (
    <Box>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
        gap={1}
      >
        <Box display={"flex"} alignItems={"center"}>
          <CustomPopover
            buttonLabel={
              <>
                <Typography
                  fontSize={20}
                  fontWeight={600}
                  sx={(theme) => ({
                    [theme.breakpoints.down("md")]: {
                      fontSize: pxToRem(16),
                    },
                  })}
                >
                  {listReports.find((it) => it.value === type)?.label}
                </Typography>
                <IconButton
                  sx={(theme) => ({
                    svg: { path: { fill: theme.palette.colorsBase.gray_10 } },
                    pointerEvents: "none",
                  })}
                >
                  <IconArrowHeadDown />
                </IconButton>
              </>
            }
            styleButton={{
              border: "none",
              backgroundColor: "unset",
              ":hover": {
                backgroundColor: "unset",
                border: "none",
                borderColor: "unset",
              },
            }}
          >
            {({ props, onClose }) => (
              <>
                {listReports.map((it, index) => (
                  <Box
                    key={index}
                    display={"flex"}
                    alignItems={"center"}
                    padding={pxToRem(12)}
                    paddingRight={pxToRem(20)}
                    sx={(theme) => ({
                      cursor: "pointer",
                      borderBottom: `solid 1px ${theme.palette.colorsBase.blue_9}`,
                      "&:hover": {
                        backgroundColor: theme.palette.colorsBase.blue_10,
                      },
                    })}
                    onClick={() => {
                      dispatch(
                        formFilterHrReportUpdate({
                          type: it?.value,
                        })
                      );
                      resetTimeSelected();
                      onClose();
                    }}
                  >
                    <Typography fontSize={14} fontWeight={600}>
                      {it?.label}
                    </Typography>
                  </Box>
                ))}
              </>
            )}
          </CustomPopover>
        </Box>
        <Box display={"flex"} alignItems={"center"} gap={1} flexWrap={"wrap"}>
          {[
            EXPORT_TYPE.LEAVE_REPORT,
            EXPORT_TYPE.COMPENSATORY_LEAVE_REPORT,
          ].includes(type) ? (
            <Box
              sx={(theme) => ({
                display: "flex",
                alignItems: "center",
                border: `solid 1px ${theme.palette.colorsBase.blue_8}`,
                borderRadius: pxToRem(8),
                paddingInline: pxToRem(12),
                paddingBlock: pxToRem(2),
              })}
            >
              <CustomCalendar
                label="Tháng"
                value={toMonthSelected}
                onChange={handleChangeToMonth}
                format="MM"
              />
            </Box>
          ) : (
            <Box
              sx={(theme) => ({
                display: "flex",
                alignItems: "center",
                border: `solid 1px ${theme.palette.colorsBase.blue_8}`,
                borderRadius: pxToRem(8),
                paddingInline: pxToRem(12),
                paddingBlock: pxToRem(2),
              })}
            >
              <CustomCalendar
                label="Từ"
                value={fromMonthSelected}
                onChange={handleChangeFromMonth}
                maxDate={toMonthSelected}
              />
              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={{ marginRight: 1 }}
              />
              <CustomCalendar
                label="Đến"
                value={toMonthSelected}
                onChange={handleChangeToMonth}
                minDate={fromMonthSelected}
              />
            </Box>
          )}
          <Button
            variant="outlined"
            onClick={handleExport}
            endIcon={<IconDownload />}
          >
            Xuất Excel
          </Button>
        </Box>
      </Box>
      {/* Filter  */}
      <FilterReport />
      {/*  table */}
      {/* {status === ReduxStateType.LOADING ? (
        <Skeleton variant="rectangular" width={"100%"} height={pxToRem(300)} />
      ) : ( */}
      <TableWrapper>
        <ViewTable
          id="hrReport"
          data={data || []}
          columns={columns}
          expanded={true}
          columnPinning={{
            left: [],
            right: [],
          }}
          handleFetchMore={() => {
            setTimeout(() => {
              dispatch(getHrReportStart());
            }, 10);
          }}
          messageEmpty={
            <EmptyState
              message="Không có dữ liệu"
              sx={(theme) => ({
                h6: {
                  color: theme.palette.text.textSecondary,
                },
              })}
            />
          }
          handleOnClickedRow={(item) => {
            // item.id;
          }}
          handleSelection={(e) => {}}
          height={600}
          isHasMore={data?.length < totalRecords}
        />
      </TableWrapper>
      {/* )} */}
    </Box>
  );
};
